import { Flex } from "grid-styled";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import system from "system-components";

import DropdownMenu from "pstat-anywhere/components/partials/DropdownMenu";
import { StyledFontAwesomeIcon } from "pstat-anywhere/components/partials/icons";
import MenuLink, {
  SelectedMenuLabel
} from "pstat-anywhere/components/partials/MenuLink";
import { TextInputWithIcon } from "pstat-design-system/inputs/TextInput";

const DropdownBlocItem = styled.li`
  display: block;
  float: none;
`;

const AccessibleBlocDropdownItems = ({
  selectedBlocPk,
  items,
  systemDocumentTemplate
}) => {
  const { t } = useTranslation();
  const [filterQuery, setFilterQuery] = useState("");
  const handleSearchValue = event => setFilterQuery(event.target.value);
  const {
    bloc: { name: templateBlocName },
    link: templateLink
  } = systemDocumentTemplate || {};

  const filterBlocsByName = items => {
    const query = filterQuery.toLowerCase();
    return items.filter(
      ({ bloc: { name: blocName } }) =>
        blocName.toLowerCase().indexOf(query) !== -1
    );
  };

  const filteredTenants = filterBlocsByName(items);
  const blocItems = filteredTenants.map(({ bloc: { pk, name }, link }) => {
    return (
      <DropdownBlocItem key={pk}>
        {selectedBlocPk === pk ? (
          <SelectedMenuLabel>{name}</SelectedMenuLabel>
        ) : (
          <MenuLink href={link}>{name}</MenuLink>
        )}
      </DropdownBlocItem>
    );
  });
  return (
    <Fragment>
      <Flex px={4} py={2}>
        <TextInputWithIcon
          icon={["far", "search"]}
          side="left"
          value={filterQuery}
          onChange={handleSearchValue}
          placeholder={t("siteSelector.filterLocation")}
        />
      </Flex>
      {systemDocumentTemplate && (
        <DropdownBlocItem>
          <MenuLink href={templateLink}>{templateBlocName}</MenuLink>
        </DropdownBlocItem>
      )}
      {blocItems}
    </Fragment>
  );
};

const ButtonBadge = system({
  is: "button",
  textAlign: "left",
  bg: "transparent",
  border: 1,
  borderColor: "primary.0",
  borderRadius: 3,
  px: 4,
  py: 1,
  my: 1,
  fontSize: [1],
  fontWeight: "medium",
  minWidth: "28px",
  color: "secondary.0"
}).extend`
  cursor: pointer;
  text-decoration: underline;
`;

const BlocSelector = props => {
  const { onClick, title } = props;
  return (
    <ButtonBadge
      onClick={onClick}
      data-testid="bloc-selector-button"
      data-tip={true}
      data-for="applicability-tenants-tooltip"
    >
      {title} <StyledFontAwesomeIcon icon={["far", "chevron-down"]} />
    </ButtonBadge>
  );
};

export const AccessibleBlocsForAdoptedDocuments = ({
  title,
  items,
  blocPk,
  systemDocumentTemplate
}) => {
  const [expanded, setExpanded] = useState(false);
  const closeDropdown = () => setExpanded(false);
  const toggle = () => setExpanded(!expanded);

  return (
    <DropdownMenu
      dropdownSelector={() => <BlocSelector onClick={toggle} title={title} />}
      expanded={expanded}
      rtl={false}
      toggle={toggle}
      closeMenu={closeDropdown}
      width={"300px"}
    >
      <AccessibleBlocDropdownItems
        items={items}
        selectedBlocPk={blocPk}
        systemDocumentTemplate={systemDocumentTemplate}
      />
    </DropdownMenu>
  );
};
